<template>
  <div>
    <h3 class="mb-5">Main Visual</h3>
    <div class="h4 mb-5">
      顯示於產品頁置頂區域
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in csr.main" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Banner {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(i)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Slogan -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Slogan</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 Slogan"
                v-model="item.title"
              />
            </div>
          </div>
        </label>
        <!-- Subtitle -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">URL</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 URL"
                v-model="item.subtitle"
              />
            </div>
          </div>
        </label>

        <!-- 文字位置 -->
        <div class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">圖片位置</h4>
          <div class="flex-grow-1 mt-3">
            <v-radio-group v-model="item.text_position" row>
              <div
                v-for="item in [
                  { label: '上方', value: 'top' },
                  { label: '中間', value: 'middle' },
                ]"
                :key="item.value"
                class="w-33"
              >
                <v-radio class="mr-01" :value="item.value">
                  <template v-slot:label>
                    <div class="ink-01-emphasis--text w-202px">
                      {{ item.label }}
                    </div>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
          </div>
        </div>
        <!-- 顯示/隱藏 -->
        <div class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">顯示/隱藏</h4>
          <div class="flex-grow-1 mt-3">
            <FormSwitch v-model="item.status"></FormSwitch>
          </div>
        </div>
        <!-- 簡介 -->
        <label class="form-item d-flex pb-3" v-if="csr.bu_id == 1">
          <h4 class="w-180px mt-5">簡介</h4>
          <div class="flex-grow-1 mt-3">
            <editor
              v-model="item.description"
              :plugins="'link'"
              :toolbar="'link'"
            />
          </div>
        </label>

        <!-- img uploader(PC) -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">圖片</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.image"
              dir="product"></ImgUploader>
          </div>
        </div>

        <!-- img uploader(Mobile) -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">圖片(Mobile)</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：480px * 850px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.image_mobile"
              dir="csr"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- 添加Company Culture -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Banner</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  props: {
    csr: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
    Editor,
    FormSwitch,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        subtitle: '',
        text_position: 'top',
        image: '',
        description: '',
        image_mobile: '',
        status: false,
      };
      this.csr.main.push(template);
    },
    deleteItem(index) {
      this.csr.main.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.csr.main.length - 1) {
        this.csr.main.splice(i, 1);
        this.csr.main.unshift(item);
        return;
      }
      // item become next index
      this.csr.main.splice(i, 1);
      this.csr.main.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.csr.main.splice(i, 1);
        this.csr.main.push(item);
        return;
      }
      // item become previous index
      this.csr.main.splice(i, 1);
      this.csr.main.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
